import { render, staticRenderFns } from "./TemplateSettingDialog.vue?vue&type=template&id=dc06b7ce&scoped=true"
import script from "./TemplateSettingDialog.vue?vue&type=script&lang=js"
export * from "./TemplateSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./TemplateSettingDialog.vue?vue&type=style&index=0&id=dc06b7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc06b7ce",
  null
  
)

export default component.exports